/**
 * AI-SRM 静态资源路径
 *
 * - 图片：随工程发布，位于 public/images/aip/srm/，统一经 srmAsset() 拼接（业务代码不得出现裸路径）
 * - 视频：已上传 OSS，经 srmVideo() 按语义名取地址
 * - 后续图片也整体上 OSS 时，只改 SRM_ASSET_BASE 一处即可
 */
export const SRM_ASSET_BASE = '/images/aip/srm';

/** 拼接资源绝对路径，入参为相对 SRM_ASSET_BASE 的路径，如 'overview/hero.webp' */
export const srmAsset = (relativePath: string): string => `${SRM_ASSET_BASE}/${relativePath}`;

/** 演示视频语义名（与 scripts/migrate-ai-srm-assets.mjs 产出的文件名一一对应） */
export type SrmVideoName =
  | 'demand-forecast'
  | 'centralized-sourcing-insight'
  | 'delivery-tracking'
  | 'invoice-settlement'
  | 'sourcing-tender'
  | 'bid-evaluation'
  | 'contract-drafting'
  | 'material-master-governance'
  | 'supplier-lifecycle';

const SRM_VIDEO_OSS_BASE = 'https://terminus-emp.oss-cn-hangzhou.aliyuncs.com/trantor2/portal/CLOUD_PROCUREMENT_SALES';

/** 演示视频 OSS 地址（已上传，直接引用） */
const SRM_VIDEO_MAP: Record<SrmVideoName, string> = {
  'demand-forecast': `${SRM_VIDEO_OSS_BASE}/f3d957b3-2cd4-4e49-bff1-5d9d9aaabbd3/demand-forecast.mp4`,
  'centralized-sourcing-insight': `${SRM_VIDEO_OSS_BASE}/685d44e3-41c4-447b-9fba-77247d839261/centralized-sourcing-insight.mp4`,
  'delivery-tracking': `${SRM_VIDEO_OSS_BASE}/2a2d8c42-42a4-4aac-b0b7-84d69f29e8c2/delivery-tracking.mp4`,
  'invoice-settlement': `${SRM_VIDEO_OSS_BASE}/0ae57111-8955-45f4-a9dd-663955cb9a35/invoice-settlement.mp4`,
  'sourcing-tender': `${SRM_VIDEO_OSS_BASE}/40a4e518-b24e-4cd9-a174-d0ebc2ce9d25/sourcing-tender.mp4`,
  'bid-evaluation': `${SRM_VIDEO_OSS_BASE}/e3626fc0-c807-411d-96b5-058a1efdc2cf/bid-evaluation.mp4`,
  'contract-drafting': `${SRM_VIDEO_OSS_BASE}/5ca9f9be-9266-4bc3-8b9e-f621d9752f2d/contract-drafting.mp4`,
  'material-master-governance': `${SRM_VIDEO_OSS_BASE}/732bd4d1-6f99-410e-bfd6-3769d9c01ba8/material-master-governance.mp4`,
  'supplier-lifecycle': `${SRM_VIDEO_OSS_BASE}/aca6dffc-9a65-4440-9d42-763a844ac9bc/supplier-lifecycle.mp4`
};

/** 取演示视频地址 */
export const srmVideo = (name: SrmVideoName): string => SRM_VIDEO_MAP[name];
